import {clientConfig} from "../config/clientConfig";

const host =  clientConfig.apiBaseUrl
export async function getCourses() {
  let res = await fetch(host + "/courses", {
    method: "GET", credentials: "include"
  });
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function getCourseInfo(id) {
  let res = await fetch(host + "/courses/" + id , {
    method: "GET", credentials: "include"
  });
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}


/**
 * gets the display info of the courses supplied
 * @param {Array} ids
 */
export async function getCoursesDisplayInfo(ids) {
  let res = await fetch(host + "/courses/display?ids=" + ids.join(",") , {
    method: "GET", credentials: "include"
  });
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function getEnrolledCourseInfo(userid) {
  let res = await fetch(host + "/users/" + userid + "/courses", {
    method: "GET", credentials: "include"
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function getCourseMaterial(id) {
  let res = await fetch(host + "/courses/" + id + "/materials", {
    method: "GET", credentials: "include"
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function getCourseUsers(id) {
  let res = await fetch(host + `/courses/${id}/users`, {
    method: "GET", credentials: "include"
  });
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function getCourseForum(id) {
  let res = await fetch(host + `/courses/${id}/forum`, {
    method: "GET", credentials: "include"
  });
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function getCourseForumTopic(courseId, topicId) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}`, {
    method: "GET", credentials: "include"
  });
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}



export function getVidUrl(name) {
  return host + `/uploads/videos/${name}`;
}

export function getFileUrl(name) {
  return host + `/uploads/other/${name}`;
}

export async function getCourseMaterialInfo(id,courseId) {
  let res = await fetch(host + `/courses/${courseId}/materials/${id}`, {
    method: "GET", credentials: "include"
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function checkRating(type, id) {
  let res = await fetch(host + `/${type}/${id}/rate`, {
    method: "GET", credentials: "include"
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function postComment(courseId, content, parentId, materialId, username) {
  let res = await fetch(host + `/courses/${courseId}/materials/${materialId}/comments`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      content: content,
      parentId: parentId,
      name: username
    }),
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function rateCourse(type, id, notes, rating) {
  let res = await fetch(host + `/${type}/${id}/rate`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      rating: rating,
      notes: notes
    }),
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function removeCourseUser(courseId, userid) {
  let res = await fetch(host + `/courses/${courseId}/users/${userid}`, {
    method:"DELETE", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function likeComment(courseId, commentId, materialId) {
  let res = await fetch(host + `/courses/${courseId}/materials/${materialId}/comments/${commentId}/like`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function likeTopic(courseId, topicId) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/like`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}


export async function likeTopicComment(courseId, topicId, replyId) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/reply/${replyId}/like`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}


export async function deleteTopicComment(courseId, topicId, replyId) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/reply/${replyId}/`, {
    method:"DELETE", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function unlikeTopicComment(courseId, topicId, replyId) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/reply/${replyId}/unlike`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function editTopicComment(courseId, topicId, replyId, content) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/reply/${replyId}/`, {
    method:"PUT", credentials:"include",headers: {
      'Content-Type': 'application/json',
    },
  body: JSON.stringify({content})});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function replyTopic(courseId, topicId, content) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/reply`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({content})
  });
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function unlikeTopic(courseId, topicId) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/unlike`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function deleteComment(courseId, commentId, materialId) {
  let res = await fetch(host + `/courses/${courseId}/materials/${materialId}/comments/${commentId}`, {
    method:"DELETE", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function unLikeComment(courseId, commentId, materialId) {
  let res = await fetch(host + `/courses/${courseId}/materials/${materialId}/comments/${commentId}/unlike`, {
    method:"POST", credentials:"include",headers: {
      'Content-Type': 'application/json',
    }});
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}


export async function buyItems(items, action) {
  let res = await fetch(host + "/payments/create_payment" , {
    method: "POST", credentials: "include",

    headers: {
    'Accept': 'application/json',
      'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    items: items,
    action
  })});
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}


export async function createAnnouncement(courseId, title, content) {
  let res = await fetch(host + `/courses/${courseId}/announcement` , {
    method: "POST", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      title, content
    })});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}


export async function createTopic(courseId, title, content) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic` , {
    method: "POST", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      title, content
    })});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function deleteTopic(courseId, topicId) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}` , {
    method: "DELETE", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function editTopic(courseId, topicId, title, content) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}` , {
    method: "PUT", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }, body: JSON.stringify({title, content})});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function lockTopic(courseId, topicId, locked) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/lock` , {
    method: "PUT", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }, body: JSON.stringify({locked})});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function pinTopic(courseId, topicId, pinned) {
  let res = await fetch(host + `/courses/${courseId}/forum/topic/${topicId}/pin` , {
    method: "PUT", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }, body: JSON.stringify({pinned})});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function editAnnouncement(courseId, title, content, announcementId) {
  let res = await fetch(host + `/courses/${courseId}/announcement/${announcementId}` , {
    method: "PUT", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      title, content
    })});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}


export async function deleteAnnouncement(courseId, announcementId) {
  let res = await fetch(host + `/courses/${courseId}/announcement/${announcementId}` , {
    method: "DELETE", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }});
  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}




export async function register(courseId) {
  let res = await fetch(host + `/courses/${courseId}/register/` , {
    method: "POST", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },});
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function deleteRating(type, id, ratingId) {
  let res = await fetch(host + `/${type}/${id}/rate/${ratingId}` , {
    method: "DELETE", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function deleteCourse(courseId) {
  let res = await fetch(host + `/courses/${courseId}/` , {
    method: "DELETE", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}


export async function deleteMaterial(materialId, courseId) {
  let res = await fetch(host + `/courses/${courseId}/materials/${materialId}` , {
    method: "DELETE", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },});
  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function unregister(courseId) {
  let res = await fetch(host + `/courses/${courseId}/unregister/` , {
    method: "POST", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },});
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function completeMaterial(courseId, materialId) {
  let res = await fetch(host + `/courses/${courseId}/materials/${materialId}/complete` , {
    method: "POST", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },});
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function unCompleteMaterial(materialId) {
  let res = await fetch(host + `/materials/${materialId}/uncomplete` , {
    method: "POST", credentials: "include",

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },});
  if (res.status !== 403) {
    return await res.json();
  } else {
    return undefined;
  }
}


export async function updateMaterial(materialId, courseId, updatedFields) {
  console.log(updatedFields);
  let res = await fetch(`${host}/courses/${courseId}/materials/${materialId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updatedFields)
  });

  if (res.status === 200) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function updateMaterialsOrder(courseId, updatedMaterials) {
  console.log(updatedMaterials);
  let res = await fetch(`${host}/courses/${courseId}/materials/update-order`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updatedMaterials)
  });

  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}



export async function updateCourse(materialId, updatedFields) {
  console.log(updatedFields);
  let res = await fetch(`${host}/courses/${materialId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updatedFields)
  });

  if (res.status === 200) {
    return await res.json();
  } else {
    return  res.status;
  }
}

export async function fetchTrainers() {
  const res = await fetch(`${host}/users/trainers`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  return await res.json();
}

export async function createCertificate(type, id) {
  const res = await fetch(`${host}/${type}/${id}/certificate`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  return await res.json();
}


export async function uploadFileAndUpdate(file) {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(`${host}/upload`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });

    if (response.status === 200) {
      return await response.json();
    } else {
      return response.status;
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    return undefined;
  }
};

// Function to create a new material
export async function createMaterial(materialData, courseId) {
  let res = await fetch(`${host}/courses/${courseId}/materials`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(materialData)
  });

    return await res.json();
}

export async function createCourse(courseData) {
  let res = await fetch(`${host}/courses`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(courseData)
  });

  if (res.status === 201) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function submitQuiz(materialId) {
  let res = await fetch(`${host}/materials/${materialId}/submit-quiz`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  if (res.status !== 500) {
    return await res.json();
  } else {
    return undefined;
  }
}

export async function submitAnswer(materialId, index, answer) {
  let res = await fetch(`${host}/materials/${materialId}/submit-answer`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({answer, index})
  });

  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

export async function startQuizSession(materialId) {
  let res = await fetch(`${host}/materials/${materialId}/start-quiz`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  if (res.status === 200) {
    return await res.json();
  } else {
    return res.status;
  }
}

